/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useContext, useState } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import moment from 'moment';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import { Storage } from 'aws-amplify';

const TableBody = ({
    tableData, 
    getListData,
    indexNum,  
    setToastErrorMessage }) => {
    const {setToastmessage, isInactiveBranch} =  useContext(GlobalContext);
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const [activateOpen, setActivateOpen] = useState(false);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const handleConformationClick = () => {
        setActivateOpen(!activateOpen)
    }

    
    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            const branch_id = await GetBranchId()
            let endpoint= `payroll?branch_id=${branch_id}&financial_year=${tableData?.financial_year}&month=${tableData?.month}`
            const response = await dataService.DeleteAPI(endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastmessage(`Payroll deleted successfully`);
            getListData()
        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }    }

    /**
     * The function `downloadPayrollHandler` downloads a payroll file using an API call and displays a
     * success message or error message accordingly.
     */
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false)
    const downloadPayrollHandler = async () => {
        if(downloadBtnLoading) return
        try {
            setDownloadBtnLoading(true)
            const branch_id = await GetBranchId();
            const res = await dataService.GetAPI(`payroll/${tableData?.id}?branch_id=${branch_id}`)
            window.open(res.data.data.presigned_url, '_blank');
            setToastmessage("Payroll downloaded successfully");
        } catch (error) {
            console.error(error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally{
            setDownloadBtnLoading(false)
        }
    };

    return (
        <>
            <AnimatedList
                rowStatus={true}
                keyItem={indexNum}
                handleClick={()=>{}}
                child={
                    <>
                        <td class="text-start capitalize">{tableData?.month || "-"}</td>
                        <td class="text-end">{tableData?.number_of_employees || "-"}</td>
                        <td class="text-start">{moment.utc(tableData?.uploaded_at).format('MMM DD, YYYY') || "-"}</td>
                        <td class="text-start ">{tableData?.uploaded_by || "-"}</td>
                        <td class="">
                            <span className='pt-2 flex justify-center' title='Click to download'>
                                {downloadBtnLoading ? <div className='flex items-center justify-center w-[35px]'>
                                    <div className="loader-blue ease-linear rounded-full border-t-4 border-[#1A6EB4] h-[15px] w-[15px] spin-animation"></div>
                                </div> : <img src="/images/payroll-document-icon.svg" alt="icon"  
                                    className='cursor-pointer' 
                                    onClick={()=>{downloadPayrollHandler()}}
                                    id='download-payroll'
                                />}
                            </span>
                        </td>
                        <td class="text-start">{tableData?.note || "-"}</td>
                        <td class="prevent-click">
                            <div className='w-full flex justify-center'>
                                <button
                                    id='edit'
                                    type='button'
                                    disabled = {isInactiveBranch}
                                    onClick={() => handleConformationClick()}
                                    class={`list-actn-btn`}
                                >Delete</button>
                            </div>
                        </td>
                    </>
                    
                }/>
          
            
            {activateOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`Delete Payroll`}
                        message = {`Are you sure you want to delete the uploaded payroll document for '${tableData?.financial_year} Month: ${tableData?.month}'`}
                        buttonName = {`Delete`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </>
        
    );
}

export default TableBody;
